import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsParkingPassesService} from '../../../services/settings-parking-passes.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'disclaimer-modal',
    templateUrl: './disclaimer-modal.component.html',
    styleUrls: ['./disclaimer-modal.component.scss']
})
export class DisclaimerModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    disclaimer = '';

    constructor(
        public api: ApiClientService,
        public settingsParkingPassesService: SettingsParkingPassesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.disclaimer = this.settingsParkingPassesService.selectedItemData.disclaimer ? this.settingsParkingPassesService.selectedItemData.disclaimer.slice() : '';
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsParkingPassesService.isDisclaimerModalShow = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParkingPassesService.isDisclaimerModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if(this.disclaimer == '' || (this.disclaimer.replace(/&nbsp;/g, '')).replace(/\s/g, '').replace(/<br>/g, '') == '') {
            toastr.warning('Disclaimer should not be blank.');
            return;
        }

        const data = { disclaimer : this.disclaimer };
        this.disabledSubmit = true;
        const url = `${this.settingsParkingPassesService.parkingPassesData.rules.patch}${this.settingsParkingPassesService.selectedItemData.id}.json`;
        this.settingsParkingPassesService.api.patch('domainParkingPass', url, data).subscribe(
            () => this.updateView('The Disclaimer was successfully updated'),
            (error) => this.api.errorHandler(error, 'Update failed!'),
            () => { this.disabledSubmit = false; }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsParkingPassesService.getData();
        this.form.reset();
        this.hideModal();
    }

    initSummernote(id) {
        const summernote = $(id);
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => this.disclaimer = contents },
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        $('.note-editable').html(this.disclaimer).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote('#summernote'), 300);
    }

    closeEditPanel() {
        this.showEditPanel = false;
        this.disclaimer = this.settingsParkingPassesService.selectedItemData.disclaimer ? this.settingsParkingPassesService.selectedItemData.disclaimer.slice() : '';
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/disclaimer-modal/disclaimer-modal.component.ts